export const ALT_IMAGE_NO_SELECTION = 'no_selection';
